import { useEffect, useState, useMemo } from 'react';
import { throttle } from 'lodash';

const useBannerOffset = (elementRef) => {
    const [scrollOffsetTop, setScrollOffsetTop] = useState(350);

    const updateScrollOffset = () => {
        if (elementRef && elementRef?.current) {
            let rectTop = elementRef.current.getBoundingClientRect().top;
            if (rectTop && rectTop > 300) {
                setScrollOffsetTop(rectTop);
            }
        }
    }

    const throttleUpdateScrollOffset = useMemo(() => throttle(updateScrollOffset, 150), []);

    useEffect(() => {
        window.addEventListener("resize", throttleUpdateScrollOffset);
        updateScrollOffset();
        return () => {
            window.removeEventListener("resize", throttleUpdateScrollOffset);
            throttleUpdateScrollOffset.cancel();
        }
    }, [elementRef]);

    return scrollOffsetTop;
};

export default useBannerOffset;